// extracted by mini-css-extract-plugin
export default {"content":"Content_content__SCOVj","table-wrapper":"Content_table-wrapper__yFmN6","pagination-wrapper":"Content_pagination-wrapper__lAwQv"};